import Layout, {Content} from 'antd/lib/layout/layout';
import {CrudForm, CrudFormItemProps, CrudFormWrapperProps} from "digimuth-components/dist";
import AuthenticationLayout from '../authenticationLayout';
import styles from "./forgotPassword.module.scss";

const layout = {
    labelCol: {span: 8},
    wrapperCol: {span: 8},
};

const tailLayout = {
    wrapperCol: {offset: 8, span: 4},
};

const formItems: CrudFormItemProps[] = [{
    name: "email",
    rules: [
        {required: true, message: 'To pole jest wymagane'},
        {type: "email", message: "Format adresu email jest niepoprawny"}
    ]
}];

export default function ForgotPassword(props: CrudFormWrapperProps<any>) {
    return <CrudForm
                onSubmit={props.onSubmit}
                formItems={formItems}
                saveButtonTitle="Resetuj hasło"
                formProps={layout}
                tailProps={tailLayout}/>;
}
